import React from 'react';
import moment from 'moment';

const Battery = ({ caseTime, reportTime }) => {
  const calculateBatteryColor = () => {
    const caseDate = moment(caseTime, 'MM/DD/YYYY, h:mm:ss a'); // Parse caseTime using the specified format
    //const currentTime = moment(reportTime, 'DD/MM/YYYY, h:mm:ss a'); // Get the current time
    const currentTime = moment(reportTime); // Get the current time

    const timeDiff = currentTime.diff(caseDate, 'hours'); // Calculate the time difference in hours
    //const timeDiff = caseDate.diff(currentTime, 'hours'); // Calculate the time difference in hours

    if (timeDiff < 1) {
      return { color: 'green', barsCount: 4 };
    } else if (timeDiff < 2) {
      return { color: 'yellow', barsCount: 3 };
    } else if (timeDiff < 3) {
      return { color: 'orange', barsCount: 2 };
    } else if (timeDiff < 4) {
      return { color: 'red', barsCount: 1 };
    } else {
      return { color: 'empty', barsCount: 0 };
    }
  };

  const { color, barsCount } = calculateBatteryColor();

  return (
    <div className={`battery-indicator ${color}`}>
      <div className="battery d-inline-flex flex-column battery-vertical">
        <div className="battery-cap m-auto bg-dark"></div>
        <div className="battery-body border border-dark d-flex flex-column-reverse align-items-center">
          {[...Array(barsCount)].map((_, index) => (
            <div key={index} className="battery-bar" style={{ backgroundColor: color }}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Battery;
